import Unit from '@leverege/unit';
import UnitFormatter from './UnitFormatter.js';
import UnitFormatterModel from './UnitFormatterModel.js';
import UnitFormatterEditor from "./UnitFormatterEditor.js";
let formatters;

// Set up Unit specific format models and editors
function createUnitFormatters() {
  if (!formatters) {
    formatters = {};
    const types = Unit.getUnitTypes();
    types.forEach(type => {
      const key = `${type[0].toUpperCase()}${type.substring(1)}`;
      const model = UnitFormatterModel.createFor(type);
      const editor = UnitFormatterEditor.createFor(type);
      formatters[`${key}FormatterModel`] = model;
      formatters[`${key}FormatterEditor`] = editor;
      formatters[`${key}Formatter`] = UnitFormatter;
    });
  }
  return formatters;
}
export default {
  createUnitFormatters
};